var map = {
	"./alien.svg": 333,
	"./cornuvotia.svg": 9464,
	"./deamon.svg": 5812,
	"./dragon.svg": 6121,
	"./dwarf.svg": 880,
	"./elf.svg": 3287,
	"./ghost.svg": 6029,
	"./goblin.svg": 7189,
	"./griffin.svg": 6605,
	"./mermaid.svg": 3513,
	"./orc.svg": 3878,
	"./phoenix.svg": 673,
	"./pirate.svg": 7787,
	"./questionmark.svg": 3055,
	"./sphinx.svg": 2754,
	"./troll.svg": 8509,
	"./unicorn.svg": 5552,
	"./vampire.svg": 9658,
	"./witch.svg": 9297,
	"./wizard.svg": 3845,
	"./zombie.svg": 1726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9461;